import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'kx-month-year-view',
    templateUrl: './month-year-view.component.html',
    styleUrls: ['./month-year-view.component.scss'],
    standalone: false
})
export class MonthYearViewComponent implements OnInit {
  @Input() value: any;
  @Input() type: any

  constructor() { }

  ngOnInit() {
  }

}
